import { useEditor, useNode } from "@craftjs/core";
import React from "react";

import {
  PencilActiveIcon,
  PaintIcon,
  SettingsIcon,
} from "../../../assets/ui-icons";
import { isUpdatedFromDefault } from "../../utils";

import {
  ColorInput,
  PaddingInput,
  Panel,
  RangeInput,
  SelectInput,
  SpacerInput,
  Tabs,
} from "./../../ui-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTableColumns } from "@fortawesome/free-solid-svg-icons";
import RightBar from "../../ui-kit/rightbar";
import { IconPack } from "../../../assets/icon-pack";

export const CMSColumnsSettings = () => {
  const {
    id,
    actions: { setProp },
    props,
  } = useNode((node) => ({
    id: node.id,
    text: node.data.props.text,
    props: node.data.props,
  }));

  const {
    query: { node, parseFreshNode },
  } = useEditor();

  const {
    columnsCount = node(id).childNodes().length,
    textColor,
    backgroundColor,
    layoutPadding,
    width,
    maxWidth,
    minWidth,
    alignItems,
  } = props;

  const General = () => {
    return (
      <>
        <SpacerInput ypadding={"0"}>
          <RangeInput
            label="Total Columns"
            value={columnsCount}
            onChange={(val) => {
              setProp((props) => {
                props.columnsCount = val;
              });
            }}
          />
          <RangeInput
            label="Width"
            value={width}
            onChange={(val) => {
              setProp((props) => {
                props.width = val + "%";
              });
            }}
          />
          <RangeInput
            label="Max Width"
            value={maxWidth}
            onChange={(val) => {
              setProp((props) => {
                props.maxWidth = val + "%";
              });
            }}
          />
          <RangeInput
            label="Min Width"
            value={minWidth}
            onChange={(val) => {
              setProp((props) => {
                props.minWidth = val + "%";
              });
            }}
          />
          <SelectInput
            label="Vertical Align"
            value={alignItems}
            onChange={(val) => {
              setProp((props) => {
                props.alignItems = val;
              });
            }}
            options={[
              {
                label: "Start",
                value: "start",
              },
              {
                label: "Center",
                value: "center",
              },

              {
                label: "End",
                value: "end",
              },
            ]}
          />
        </SpacerInput>
      </>
    );
  };

  const Styles = () => {
    return (
      <div className="w-full rounded-[21px] py-2 bg-white flex flex-col">
        <Panel label={"Colors"} isOpen={true}>
          <SpacerInput>
            <ColorInput
              value={textColor}
              onChange={(val) => {
                setProp((props) => {
                  props.textColor = val;
                });
              }}
              label={"Text"}
              useTextColorPalette={true}
            />
            <ColorInput
              value={backgroundColor}
              onChange={(val) => {
                setProp((props) => {
                  props.backgroundColor = val;
                });
              }}
              label={"Background"}
            />
          </SpacerInput>
        </Panel>
      </div>
    );
  };

  const Advance = () => {
    return (
      <SpacerInput>
        <PaddingInput
          value={layoutPadding}
          onChange={(val) => {
            setProp((props) => {
              props.layoutPadding = val;
            });
          }}
        />
      </SpacerInput>
    );
  };

  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Style",
      key: "style",
      icon: IconPack.Style,
      children: Styles(),
      isUpdated: isUpdatedFromDefault([]),
    },
    {
      label: "Advanced",
      key: "advanced",
      icon: IconPack.Settings,
      children: Advance(),
      isUpdated: isUpdatedFromDefault([]),
    },
  ];
  return (
    <div className="h-full w-[330px] post-edit-right-sidebar p-2 overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between">
          <RightBar
            title={"Columns"}
            icon={
              <FontAwesomeIcon
                icon={faTableColumns}
                size="2xl"
                color="#8402E9"
              />
            }
          />
        </div>
        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />

        <div className="py-2 bg-ui-light-white"></div>
      </div>
    </div>
  );
};
